var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafeBoxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3fbbae",
    opacity: 0.4,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 312.01 287.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.88,95q58.68,0,117.36,0c23.11,0,38.25,15.15,38.26,38.26q0,93.74,0,187.47c0,23.08-15.19,38.27-38.27,38.27H132.77c-23.06,0-38.26-15.21-38.27-38.27q0-93.74,0-187.47C94.51,110.2,109.71,95,132.77,95Q191.83,95,250.88,95Zm-.13,60a72,72,0,0,0-72.24,72.46c0,39.42,32.7,71.67,72.46,71.51,39.3-.16,71.69-32.82,71.52-72.13C322.32,187.23,290.06,154.91,250.75,155Z",
    transform: "translate(-94.5 -95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,359H190.3c0,4.8.43,9.55-.12,14.18-.64,5.55-5.57,9.52-11.28,9.62q-12.37.22-24.75,0a11.66,11.66,0,0,1-11.61-11.41C142.39,367.4,142.51,363.41,142.51,359Z",
    transform: "translate(-94.5 -95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39,359.07c0,4.63.32,9.13-.08,13.55a11.41,11.41,0,0,1-11.21,10.17q-12.57.25-25.13,0a11.5,11.5,0,0,1-11.34-10.46c-.33-4.32-.07-8.69-.07-13.26Z",
    transform: "translate(-94.5 -95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38,215c-6.9,0-13.75,0-20.6,0-7.9,0-13.33,5-13.27,12.09C262.57,234,268,239,275.64,239c6.62,0,13.23,0,19.85,0a2.74,2.74,0,0,1,.72.19C295,257.66,271.49,275.42,249,275c-24.68-.5-45.77-21.12-46.5-45.47-.8-26.64,18.06-48.33,44.12-50.32C275.05,177,293.55,198.55,296.38,215Z",
    transform: "translate(-94.5 -95)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeBoxIcon);
export default __webpack_public_path__ + "static/media/safeBoxIcon.24866c459d98b7ae2c9ab61e5d05e489.svg";
export { ForwardRef as ReactComponent };